import { render } from "./EducationType.vue?vue&type=template&id=241821e0"
import script from "./EducationType.vue?vue&type=script&lang=js"
export * from "./EducationType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__